import React from 'react'
import { ToastContainer } from 'react-toastify'
import ReactDOM from 'react-dom/client'
import '../src/styles/global.css'
import { GlobalProvider } from 'contexts/Global'
import { Routes } from './routes'
import { dataDogInit } from 'data-dog'
import { BrowserRouter as Router } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import { Provider, system } from '@welbe/design-system'

dataDogInit()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<Router>
		<Provider value={system('green')}>
			<GlobalProvider>
				<Routes />
				<ToastContainer />
			</GlobalProvider>
		</Provider>
	</Router>,
)
